
import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import '../App.css';

class Advertise extends Component{
	render(){
		return (
			<div>
               <p className="bread">
				<Link to="/">หน้าแรก</Link> > ติดต่อโฆษณา
				</p>
				<p>
				มีโปรแกรมให้ดูล่วงหน้า มีตารางบอล คะแนนบอล เพื่อให้แฟนบอลทุกท่านไม่พลาดโอกาส ในการติดตามข่าวสารฟุตบอล 
				ของทีมรัก อนาคตเรายังมีไฮไลท์ฟุตบอล ตารางถ่ายทอดสดฟุตบอล ตารางบอลวันนี้ โปรแกรมบอลวันนี้ ดูบอลออนไลน์ ให้ท่านได้ติดตาม 
				ดูบอลผ่านมือถือได้ตลอดเวลา หากท่านไม่สะดวกดูบอลผ่านคอมพิวเตอร์ รับประกันความลื่น ความคมชัด ตลอด 24 ชั่วโมง
				</p>
				<p>
					สนใจลงโฆษณากับเรา ติดต่อที่เบอร์ 081-552-32x-x
				</p>
            </div>
		);
	}
}

export default Advertise;
